import { Component, OnInit, AfterViewInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'pplus-table-edit-input',
  templateUrl: './pplus-table-edit-input.component.html',
  styleUrls: ['./pplus-table-edit-input.component.scss']
})
export class PplusTableEditInputComponent implements ICellEditorAngularComp, AfterViewInit {
  private params: any;
  public value: number;
  private cancelBeforeStart = false;

  @ViewChild('input', { read: ViewContainerRef, static: false }) public input;


  agInit(params: any): void {
    this.params = params;
    this.value = this.params.value;
  }
  clear() {
    this.value = 0;
    return this.value;
  }

  getValue(): any {
    return this.value;
  }

  // dont use afterGuiAttached for post gui events - hook into ngAfterViewInit instead for this
  ngAfterViewInit() {
    window.setTimeout(() => {
      this.input.element.nativeElement.focus();
    });
  }
}
